import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=29ac54ea&scoped=true"
import script from "./studentList.vue?vue&type=script&lang=js"
export * from "./studentList.vue?vue&type=script&lang=js"
import style0 from "./studentList.vue?vue&type=style&index=0&id=29ac54ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ac54ea",
  null
  
)

export default component.exports